export enum TaskApprovalStatusType {
  Sent = "Sent",
  Rejected = "Rejected",
  Approved = "Approved",
  PickedUp = 'PickedUp'
}
